

import { Direction, Directionality } from '@angular/cdk/bidi';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MwcMenuModeType } from './menu.types';

@Component({
  selector: '[mwc-submenu-title]',
  exportAs: 'mwcSubmenuTitle',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span mwc-icon [mwcIconfont]="mwcIcon" *ngIf="mwcIcon"></span>
    <ng-container *mwcStringTemplateOutlet="mwcTitle">
      <span>{{ mwcTitle }}</span>
    </ng-container>
    <ng-content></ng-content>
    <span
      [ngSwitch]="dir"
      *ngIf="isMenuInsideDropDown; else notDropdownTpl"
      class="mwc-dropdown-menu-submenu-expand-icon"
    >
      <span *ngSwitchCase="'rtl'" mwc-icon [mwcIconfont]="'chevron-left'" class="mwc-dropdown-menu-submenu-arrow-icon"></span>
      <span *ngSwitchDefault mwc-icon[mwcIconfont]="'chevron-right'" class="mwc-dropdown-menu-submenu-arrow-icon"></span>
    </span>
    <ng-template #notDropdownTpl>
      <span mwc-icon class="mwc-menu-submenu-arrow mwc-menu-submenu-arrow-down" mwcIconfont="chevron-down"></span>
      <span mwc-icon class="mwc-menu-submenu-arrow mwc-menu-submenu-arrow-up" mwcIconfont="chevron-up"></span>
    </ng-template>
  `,
  host: {
    '[class.mwc-dropdown-menu-submenu-title]': 'isMenuInsideDropDown',
    '[class.mwc-menu-submenu-title]': '!isMenuInsideDropDown',
    '[style.paddingLeft.px]': `dir === 'rtl' ? null : paddingLeft `,
    '[style.paddingRight.px]': `dir === 'rtl' ? paddingLeft : null`,
    '(click)': 'clickTitle()',
    '(mouseenter)': 'setMouseState(true)',
    '(mouseleave)': 'setMouseState(false)'
  }
})
export class MwcSubMenuTitleComponent implements OnDestroy, OnInit {
  @Input() mwcIcon: string | null = null;
  @Input() mwcTitle: string | TemplateRef<void> | null = null;
  @Input() isMenuInsideDropDown = false;
  @Input() mwcDisabled = false;
  @Input() paddingLeft: number | null = null;
  @Input() mode: MwcMenuModeType = 'vertical';
  @Output() readonly toggleSubMenu = new EventEmitter();
  @Output() readonly subMenuMouseState = new EventEmitter<boolean>();

  dir: Direction = 'ltr';
  private destroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef, @Optional() private directionality: Directionality) {}
  ngOnInit(): void {
    this.dir = this.directionality.value;
    this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe((direction: Direction) => {
      this.dir = direction;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setMouseState(state: boolean): void {
    if (!this.mwcDisabled) {
      this.subMenuMouseState.next(state);
    }
  }
  clickTitle(): void {
    if (this.mode === 'inline' && !this.mwcDisabled) {
      this.toggleSubMenu.emit();
    }
  }
}
